<section class="billing-and-payment settings-panel" [class.mobile]="isMobile">
  <!-- TODO: Billing v2 - Remove the *ngIf="!(isInstitutionUser$ | async)" when the institution plan, billing and usage section is implemented -->
  <header *ngIf="(isInstitutionUser$ | async) === false" class="billing-and-payment-header head">
    <span class="material-icons go-back" (click)="goBack.emit()"> arrow_back </span>
    <div class="description">
      <div class="title">{{ PANELS?.PAYMENT?.name }}</div>
      <div class="subtitle">{{ PANELS?.PAYMENT?.description }}</div>
    </div>
    <span class="material-icons close" (click)="goBack.emit()"> close </span>
  </header>

  <!-- 
    TODO: Billing v2 - Remove the height style [style.height]="(isInstitutionUser$ | async) ? '100%' : 'calc(100% - 84px)'"
    when the institution plan, billing and usage section is implemented -->
  <main
    [style.height]="(isInstitutionUser$ | async) ? '100%' : 'calc(100% - 84px)'"
    class="billing-and-payment-main body"
  >
    <section *ngIf="(isInstitutionUser$ | async) === false">
      <ng-container
        *ngIf="(currentPlan$ | async) || (activeLegacyPlan$ | async); else noPlanTemplate"
      >
        <ng-container
          *ngTemplateOutlet="
            activePlanTemplate;
            context: { activePlan: (currentPlan$ | async) || (activeLegacyPlan$ | async) }
          "
        ></ng-container>
      </ng-container>
    </section>

    <app-trial-banner></app-trial-banner>
    <app-plan-list
      [plans]="filteredPlans$ | async"
      [currentPlan]="(currentPlan$ | async) || (activeLegacyPlan$ | async)"
      [billingStrategy]="selectedBillingStrategy$ | async"
      [billingFrequency]="billingFrequency$ | async"
      [isInstitutionUser]="isInstitutionUser$ | async"
      (billingStrategyChange)="updateBillingStrategy($event)"
      (billingFrequencyChange)="updateBillingFrequency($event)"
    ></app-plan-list>
  </main>
</section>

<ng-template #activePlanTemplate let-activePlan="activePlan">
  <section class="billing-and-payment-sub-header">
    <h3 class="billing-and-payment-sub-header-name">
      {{ 'Current Plan' | translate }}
    </h3>

    <div class="billing-and-payment-active-plan">
      <div class="billing-and-payment-active-plan-info">
        <p class="billing-and-payment-active-plan-name">
          {{ activePlan.name }}
        </p>
        <p class="billing-and-payment-active-plan-billing-frequency">
          {{
            activePlan.billingFrequency === BillingFrequency.Monthly
              ? ('Billed monthly' | translate)
              : ('Billed yearly' | translate)
          }}
        </p>
        <p class="billing-and-payment-active-plan-next-billing-date">
          {{ 'Next payment due' | translate }}
          {{ nextBillingDate$ | async | dateLocale: DateFormatEnum.LONGDATE }}
        </p>
      </div>

      <div class="billing-and-payment-active-plan-actions">
        <app-pencil-button
          [theme]="PencilButtonThemeEnum.SECONDARY_OUTLINE"
          (clickEvent)="createPortalSession()"
          data-name="settings-payment-portal-session-btn"
          icon="edit"
          [iconConfig]="{ type: 'material-icon' }"
          [label]="'Manage' | translate"
        >
        </app-pencil-button>
      </div>
    </div>
  </section>
</ng-template>

<ng-template #noPlanTemplate>
  <section class="billing-and-payment-sub-header">
    <h3 class="billing-and-payment-sub-header-name">{{ subHeaderTitle$ | async }}</h3>
    <p class="billing-and-payment-sub-header-description">{{ subHeaderDescription$ | async }}</p>
  </section>
</ng-template>
